import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface HSEAdvisorMessageDto {
  id?: number;
  businessId: number;
  fromUserId: number;
  fromUserName: string;
  toUserId: number;
  toUserName: string;
  messageContent: string;
  repliedToMessageId?: number;
  isRead: boolean;
  createdOn: Date;
  modifiedOn?: Date;
}

export interface CreateHSEAdvisorMessageDto {
  businessId: number;
  toUserId: number;
  messageContent: string;
  repliedToMessageId?: number;
}

export interface BusinessEditorDto {
  id: number;
  name: string;
  email: string;
}

@Injectable({
  providedIn: 'root'
})
export class FlexiMessageService {
  private apiUrl = `${environment.BASE_URL}/flexi`;

  constructor(private http: HttpClient) { }

  getBusinessMessages(businessId: number): Observable<HSEAdvisorMessageDto[]> {
    return this.http.get<HSEAdvisorMessageDto[]>(
      `${this.apiUrl}/messages/business/${businessId}`
    );
  }

  getReceivedMessages(businessId: number): Observable<HSEAdvisorMessageDto[]> {
    return this.http.get<HSEAdvisorMessageDto[]>(
      `${this.apiUrl}/messages/received/${businessId}`
    );
  }

  getSentMessages(businessId: number): Observable<HSEAdvisorMessageDto[]> {
    return this.http.get<HSEAdvisorMessageDto[]>(
      `${this.apiUrl}/messages/sent/${businessId}`
    );
  }

  getMessageById(messageId: number): Observable<HSEAdvisorMessageDto> {
    return this.http.get<HSEAdvisorMessageDto>(
      `${this.apiUrl}/messages/${messageId}`
    );
  }

  createMessage(message: CreateHSEAdvisorMessageDto): Observable<HSEAdvisorMessageDto> {
    return this.http.post<HSEAdvisorMessageDto>(
      `${this.apiUrl}/messages/business/${message.businessId}/create`,
      message
    );
  }

  markMessageAsRead(messageId: number): Observable<any> {
    return this.http.put(
      `${this.apiUrl}/messages/${messageId}/mark-read`,
      {}
    );
  }

  deleteMessage(messageId: number): Observable<any> {
    return this.http.delete(
      `${this.apiUrl}/messages/${messageId}`
    );
  }

  getBusinessRecipients(businessId: number): Observable<BusinessEditorDto[]> {
    return this.http.get<BusinessEditorDto[]>(
      `${this.apiUrl}/recipients/${businessId}`
    );
  }
}
